import { Component, input } from '@angular/core';
import { THREAD_AGENT_SERVICE } from 'src/app/features/general-agent/tokens/thread-agent.token';
import { THREAD_AGENT_CONFIG, GEOTECHNICAL_CHAT_THREAD_CONFIG } from 'src/app/features/general-agent/tokens/thread-agent-config.token';
import { ChatTabShellComponent } from 'src/app/features/general-agent/components/chat-tab-shell/chat-tab-shell.component';
import { ChatService } from '../../services/chat.service';
import { CHAT_TYPE, THREAD_TYPE } from '../../models/chat.model';

/**
 * Wrapper component that configures the shared ChatTabShellComponent for
 * geotechnical analysis chat. The `contractId` input receives the geotechnical
 * analysis ID which is forwarded as `documentId` in every thread request.
 */
@Component({
    selector: 'app-geotechnical-chat-tab',
    standalone: true,
    imports: [ChatTabShellComponent],
    providers: [
        /** Identifies all API/socket calls as GEOTECHNICAL_CHAT type */
        { provide: CHAT_TYPE, useValue: THREAD_TYPE.GEOTECHNICAL_CHAT },
        ChatService,
        /** Bind the generic token to the geotechnical-specific ChatService instance */
        { provide: THREAD_AGENT_SERVICE, useExisting: ChatService },
        /** Socket events and feature flags for this chat type */
        { provide: THREAD_AGENT_CONFIG, useValue: GEOTECHNICAL_CHAT_THREAD_CONFIG },
    ],
    templateUrl: './geotechnical-chat-tab.component.html',
})
export class GeotechnicalChatTabComponent {
    /** The geotechnical analysis report ID, forwarded as `documentId` in thread payloads */
    contractId = input.required<string>();
}
